/**
 * Extra ServiceApp.ai marketing blog corpus (100 long-tail SEO + AI-chat guides).
 * Merged into SERVICEAPP_BLOG_POSTS — sitemap, llms.txt and /blog pick them up automatically.
 */
import type { ServiceAppBlogPost } from './serviceappBlogPosts';
import { SERVICEAPP_BLOG_EXTRA_SEEDS } from './serviceappBlogExtraSeeds.js';

const IMG = '/serviceapp-hero-dashboard.png';
const IMG_CLEAN = '/serviceapp-owner-cleaning.jpg';
const IMG_BANNER = '/serviceapp-hero-banner.png';
const IMAGES = [IMG, IMG_CLEAN, IMG_BANNER] as const;

const EPOCH = Date.parse('2026-06-14T00:00:00.000Z');

function publishedOn(index: number): string {
  const day = new Date(EPOCH + index * 24 * 60 * 60 * 1000);
  return day.toISOString().slice(0, 10);
}

export const SERVICEAPP_BLOG_POSTS_EXTRA: ServiceAppBlogPost[] = SERVICEAPP_BLOG_EXTRA_SEEDS.map(
  (seed, index) => {
    const sibling = SERVICEAPP_BLOG_EXTRA_SEEDS[(index + 11) % SERVICEAPP_BLOG_EXTRA_SEEDS.length];
    const related = [...new Set([...seed.related, sibling.slug])].slice(0, 3);
    const published = publishedOn(index);
    return {
      slug: seed.slug,
      title: seed.title,
      description: seed.description,
      keywords: seed.keywords,
      datePublished: published,
      dateModified: published,
      category: seed.category,
      readingMinutes: 8,
      heroImage: IMAGES[index % IMAGES.length],
      heroImageAlt: `${seed.title} — ServiceApp.ai guide`,
      excerpt: seed.excerpt,
      relatedLandingSlugs: seed.landings,
      relatedPostSlugs: related,
      sections: [
        {
          heading: 'The problem owners actually have',
          paragraphs: [
            seed.pain,
            `${seed.excerpt} Search and AI chats surface this as “${seed.title}” because chat threads and spreadsheets keep failing at the same step.`,
          ],
        },
        {
          heading: 'What to do this week',
          paragraphs: [
            seed.move,
            `Write the ${seed.category.toLowerCase()} rule where the team will see it: on the job, on the quote, or on the customer record — not only in your head.`,
          ],
        },
        {
          heading: 'How ServiceApp helps',
          paragraphs: [
            seed.fit,
            'Start on the [free signup](/signup) page, or compare plans on [small business software](/small-business-software).',
          ],
        },
      ],
      faqs: [
        { q: seed.faqQ, a: seed.faqA },
        {
          q: 'Where should I start if I am still on WhatsApp and spreadsheets?',
          a: 'Put this week’s customers and open jobs into one app first. ServiceApp.ai is built for that switch, with unlimited crew and a Start from $49/mo.',
        },
      ],
    };
  },
);

export const SERVICEAPP_BLOG_EXPANSION_COUNT = SERVICEAPP_BLOG_POSTS_EXTRA.length;
